import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useModelInfo } from '../../../../common/ModelInfoContext';
import fetchStandardFeatures from '../../../../api/fetchStandardFeatures';
import makeCancellable from '../../../../common/makeCancellable';

const FetchTrimFeatures = ({ render, style }) => {
  const [features, setFeatures] = useState(null);
  const modelInfo = useModelInfo();

  useEffect(() => {
    const { cancel, promise } = makeCancellable(
      fetchStandardFeatures({ ...modelInfo, styleId: style.styleId })
    );
    promise
      .then((features) => {
        setFeatures(features);
      })
      .catch((err) => {});

    return () => {
      cancel();
    };
  }, [style]);

  return features ? render({ features }) : 'Loading...';
};

FetchTrimFeatures.propTypes = {
  style: PropTypes.object.isRequired,
  render: PropTypes.func.isRequired,
};

export default FetchTrimFeatures;
